import axios from "axios";

export const CHECKOUT_CLOSED = "checkout-closed";

export const openBundleCheckout = (
  bundleIds: string[],
  billingPeriod: "month" | "year",
  { onPaidClose }: { onPaidClose?: () => void } = {},
) =>
  new Promise((resolve, reject) => {
    let paid = false;
    window.Chargebee.getInstance().openCheckout({
      hostedPage: async () => {
        try {
          const { data } = await axios.post(
            `${process.env.REACT_APP_SPL_URL}/v2/subscriptions/checkout-update`,
            { bundles: bundleIds, billing_period: billingPeriod },
            { withCredentials: true },
          );
          // SPL wraps the payload as { hosted_page }; tolerate a bare object
          return data?.hosted_page ?? data;
        }
        catch (e) {
          reject(e);
          return null;
        }
      },
      success: () => {
        paid = true;
      },
      error: (e: unknown) => reject(e ?? new Error("Checkout failed")),
      close: () => {
        if (!paid) {
          reject(new Error(CHECKOUT_CLOSED));
          return;
        }
        onPaidClose?.();
        resolve(true);
      },
    });
  });
